import React from "react";

export default function SQL_Study_Plan() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Study_Plan</h1>
      <p>This is the SQL_Study_Plan component generated from the SQL JSON.</p>
    </div>
  );
}
